import React from 'react'
import MercadoPagoView from './mercadopago'

const MercadoPagoWithoutKyc = () => <MercadoPagoView kyc={false} />

export default MercadoPagoWithoutKyc
